import CrewingAgentDrawer from "./CrewingAgentDrawer.jsx";

const CrewingAgentLayout = () => {
  return <CrewingAgentDrawer />; // No extra wrapper
};

export default CrewingAgentLayout;
